import { Node } from '@cast/types';

import { isManagedByCASTAI } from './common';
import { NodeProvisioner } from '../_types/provisioner';
import {
  AKS_AGENTPOOL_LABEL_KEY,
  EKS_NODEGROUP_LABEL_KEY,
  GKE_NODEPOOL_LABEL_KEY,
  KARPENTER_NODEPOOL_LABEL_KEY,
} from '../constants/node-labels';

const NON_CAST_PROVISIONER_LABEL_KEYS: Array<{
  labelKey: string;
  provisioner: Exclude<NodeProvisioner, 'castai' | 'unknown'>;
}> = [
  { labelKey: AKS_AGENTPOOL_LABEL_KEY, provisioner: 'aks' },
  { labelKey: EKS_NODEGROUP_LABEL_KEY, provisioner: 'eks' },
  { labelKey: GKE_NODEPOOL_LABEL_KEY, provisioner: 'gke' },
  { labelKey: KARPENTER_NODEPOOL_LABEL_KEY, provisioner: 'karpenter' },
];

export const getNodeProvisioner = (node: Node): NodeProvisioner => {
  if (isManagedByCASTAI(node)) {
    return 'castai';
  }

  for (const { labelKey, provisioner } of NON_CAST_PROVISIONER_LABEL_KEYS) {
    if (node.labels?.[labelKey]) {
      return provisioner;
    }
  }

  return 'unknown';
};
